/*******************************************************************************
**
** Aerospace Unified Theme Scripts
**
*******************************************************************************/

import { Toast, Tooltip } from './_bootstrap';
import { CustomBtn } from './components/_aero-button';

(function () {
  // * Tooltip initialization, remove it if not necessary
  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach((tooltipElement) => new Tooltip(tooltipElement));

  // * Toast initialization, remove it if not necessary
  document
    .querySelectorAll('.toast')
    .forEach((toastElement) => new Toast(toastElement));
})();


// *******************************************************************************************
// *******************************************************************************************

//                                Components script

// *******************************************************************************************
// *******************************************************************************************
// Custom buttton script
CustomBtn();


/*******************************************************************************
**
** Aerospace Unified Theme Menu Scripts
**
*******************************************************************************/

(function(){

  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    window.addEventListener("scroll", function () {
      if (this.scrollY <= 100) {
        document.getElementsByClassName('aerospace-navigation')[0].classList.add("nav-top-100");
      }
      else {
        document.getElementsByClassName('aerospace-navigation')[0].classList.remove("nav-top-100");
      }
    }, false);
  }

  const navMenu = document.querySelector(".aerospace-navigation");

  if(navMenu) {
    const windowWidth = window.innerWidth;
    const navbarNav = navMenu.querySelector("ul.navbar-nav");
    const dropdownL1 = navMenu.querySelector(".dropdown-l1");
    const dropdownL1All = navMenu.querySelectorAll(".menu-level-one");
    const dropdownMenuList = navMenu.querySelector(".dropdown-menu-list");
    const dropdownActive = navMenu.querySelectorAll(".nav-item.menu-level-one");
    const navLink = navMenu.querySelectorAll(".menu-level-one > .nav-link");
    const navbarWrapper = navMenu.querySelector(".navbar-wrapper");
    const dropdownMenu = document.getElementById("dropdown-menu-list");

    if (windowWidth <= 1024) {
      const navbarToggler = navMenu.querySelector(".navbar-toggler");
      const body = document.querySelector("body");

      if (navbarToggler) {
        navbarToggler.addEventListener("click", () => {
          navbarToggler.classList.toggle("nav-toggled");
          navMenu.classList.toggle("mobile-nav-active");
          body.classList.toggle("mobile-menu-overlay");
        });
      }

      if (document.querySelectorAll(".first--level .menu-level-one")) {
        Array.from(document.querySelectorAll(".first--level .menu-level-one")).map((dropdownToggle) => {
          const ddmenu = dropdownToggle.querySelector(".nav-link.has-children");
          if (ddmenu) {
            dropdownToggle.addEventListener("click", (event) => {
              if (event.target.classList.contains("has-children")) {
                event.preventDefault();
                dropdownMenuList.classList.add("l2-is-active");
                if (event.target.nextElementSibling !== null && event.target.nextElementSibling.classList.contains("dropdown-menu")) {
                  event.target.nextElementSibling.classList.add("dropdown-l2-active")
                }
              }
            });
          }
        });
      }

      if (document.querySelectorAll(".dropdown-l1 .col ul>li.has-next-level")) {
        Array.from(document.querySelectorAll(".dropdown-l1 .col ul>li.has-next-level")).map((dropdownToggle) => {
          dropdownToggle.addEventListener("click", (event) => {
            dropdownMenuList.classList.add("l3-is-active");
            event.target.closest("li").nextElementSibling.classList.add("dropdown-l3-active");
          });
        });
      }
    }

    if (document.querySelectorAll(".dropdown-l1 .back-step")) {
      document.querySelectorAll(".dropdown-l1 .back-step").forEach(function (elem) {
        elem.addEventListener("click", function(event){
          event.stopPropagation();
          dropdownMenuList.classList.remove("l2-is-active");
          elem.closest(".dropdown-l1").classList.remove("dropdown-l2-active")
        })
      });
    }

    if (document.querySelectorAll(".dropdown-l3 .back-step2")) {
      document.querySelectorAll(".dropdown-l3 .back-step2").forEach(function (elem) {
        elem.addEventListener("click", function(event){
          event.stopImmediatePropagation();
          dropdownMenuList.classList.remove("l3-is-active");
          elem.closest(".dropdown-l3").classList.remove("dropdown-l3-active")
        })
      });
    }

    if (windowWidth > 1024) {
      // dropdownL1.style.width = `${navbarNav.clientWidth + 100}px`;
      let hoverTimer;

      if (dropdownL1All.length) {
        Array.from(dropdownL1All).forEach(function(dropdownItems){
          const ddmenu = dropdownItems.querySelector("div.dropdown-menu");
          if (ddmenu) {
            dropdownItems.addEventListener("mouseenter", () => {
              hoverTimer = setTimeout(() => {
                navMenu.style.background = "var(--ge-atmosphere-blue)";
                dropdownItems.classList.add("current-active");
                if (!document.querySelector("body").classList.contains("toolbar-fixed")) {
                  navbarWrapper.classList.add("mega-menu-open");
                }
                document.body.classList.add("dropmenu-overlay");
                dropdownItems.querySelector(".dropdown-menu").style.visibility  = 'visible';
                dropdownItems.querySelector(".dropdown-menu").style.opacity  = '1';
                //document.querySelector(".aerospace-logo").style.filter = "brightness(0) saturate(100%) invert(27%) sepia(14%) saturate(4742%) hue-rotate(144deg) brightness(93%) contrast(101%)";
              }, 400);
            })
            dropdownItems.addEventListener("mouseleave", () => {
              setTimeout(() => {
                navMenu.style.background = "";
                dropdownItems.classList.remove("current-active");
                if (!document.querySelector("body").classList.contains("toolbar-fixed")) {
                  navbarWrapper.classList.remove("mega-menu-open");
                }
                document.body.classList.remove("dropmenu-overlay");
              }, 400);
              clearTimeout(hoverTimer);
              dropdownItems.querySelector(".dropdown-menu").style.visibility  = 'hidden';
              dropdownItems.querySelector(".dropdown-menu").style.opacity  = '0';
              //document.querySelector(".aerospace-logo").style.filter = "";
            })
          }
        })
      }
      else {
        setTimeout(function() {
          const ddL1All = document.querySelectorAll(".aerospace-navigation .menu-level-one");
          if (ddL1All.length) {
            Array.from(ddL1All).forEach(function(dropdownItems){
              const ddmenu = dropdownItems.querySelector("div.dropdown-menu");
              if (ddmenu) {
                dropdownItems.addEventListener("mouseenter", () => {
                  hoverTimer = setTimeout(() => {
                    navMenu.style.background = "var(--ge-atmosphere-blue)";
                    dropdownItems.classList.add("current-active");
                    if (!document.querySelector("body").classList.contains("toolbar-fixed")) {
                      navbarWrapper.classList.add("mega-menu-open");
                    }
                    document.body.classList.add("dropmenu-overlay");
                    dropdownItems.querySelector(".dropdown-menu").style.visibility  = 'visible';
                    dropdownItems.querySelector(".dropdown-menu").style.opacity  = '1';
                    //document.querySelector(".aerospace-logo").style.filter = "brightness(0) saturate(100%) invert(27%) sepia(14%) saturate(4742%) hue-rotate(144deg) brightness(93%) contrast(101%)";
                  }, 400);
                })
                dropdownItems.addEventListener("mouseleave", () => {
                  setTimeout(() => {
                    navMenu.style.background = "";
                    dropdownItems.classList.remove("current-active");
                    if (!document.querySelector("body").classList.contains("toolbar-fixed")) {
                      navbarWrapper.classList.remove("mega-menu-open");
                    }
                    document.body.classList.remove("dropmenu-overlay");
                  }, 400);
                  clearTimeout(hoverTimer);
                  dropdownItems.querySelector(".dropdown-menu").style.visibility  = 'hidden';
                  dropdownItems.querySelector(".dropdown-menu").style.opacity  = '0';
                  //document.querySelector(".aerospace-logo").style.filter = "";
                })
              }
            })
          }
        }, 400);
      }


      if (dropdownL1) {
        Array.from(dropdownL1.querySelectorAll(".dropdown-navitems li")).map((menuListItem) => {
          const dropdownL2 = menuListItem.querySelector(".dropdown-l2");

          if (dropdownL2) {
            menuListItem.addEventListener("mouseenter", () => {
              menuListItem.classList.add("active-item");
              navMenu.querySelector(".default-block").style.display = "none";
            });

            menuListItem.addEventListener("mouseleave", () => {
              menuListItem.classList.remove("active-item");
              navMenu.querySelector(".default-block").style.display = "block";
            });
          }
        });
      }
    }

    if (windowWidth <= 1024) {
      navMenu.classList.add("fixed-top-mob");
    }

    window.onscroll = function(e) {
      if(windowWidth > 1024) {
        if(this.oldScroll > this.scrollY) {
          navMenu.classList.add("fixed-top");
          if(this.scrollY > 10 ) {
            navMenu.classList.add("hide-sticky-nav");
          }
          else {
            navMenu.classList.remove("hide-sticky-nav");
          }
        }
        else {
          navMenu.classList.remove("fixed-top");
        }
        this.oldScroll = this.scrollY;
      }
      else {
        if(this.scrollY > 100 ) {
          navMenu.classList.add("bg-blue");
        }
        else {
          navMenu.classList.remove("bg-blue");
        }
      }
    }
  }

  /**** Adjustments to main navigation on admin pages ****/
  window.addEventListener('load', function () {
    if (navMenu != null) {
      navMenu.classList.add("fixed-top");
    }

    let menuOffsetTop = 0;

    if (document.querySelector(".block-aero-unified-primary-local")) {
      menuOffsetTop = document.querySelector(".block-aero-unified-primary-local").offsetTop + document.querySelector(".block-aero-unified-primary-local").offsetHeight;
    }
    else if (document.querySelector("#toolbar-administration")) {
      menuOffsetTop = document.querySelector("#toolbar-administration").offsetTop;
    }

    if (document.querySelector(".aerospace-navigation.fixed-top")) {
      if (document.querySelector(".aerospace-navigation.fixed-top") != null) {
        document.querySelector(".aerospace-navigation.fixed-top").style.top = menuOffsetTop + "px";
      }
    }

    let navToggler = document.querySelector("button.navbar-toggler");
    if (navToggler != null) {
      navToggler.addEventListener('click', function (e) {
        if (navToggler.classList.contains('nav-toggled')) {
          navToggler.querySelector("span").className = '';
          navToggler.querySelector("span").classList.add("ficon-close")
          if (document.querySelector(".aerospace-navigation .navbar-wrapper")) {
            document.querySelector(".aerospace-navigation .navbar-wrapper").style.top = menuOffsetTop + "px";
          }
        }
        else {
          navToggler.querySelector("span").className = 'navbar-toggler-icon';
        }
      }, false);
    }
  }, false);
  /*******************************************************/

})();

/*******************************************************************************
**
** End of Aerospace Unified Theme Menu Scripts
**
*******************************************************************************/

/*******************************************************************************
** Form scripts
*******************************************************************************/

function formContol() {
  const formFloating = document.querySelectorAll('.form-floating');
  formFloating.forEach(formFloating => {
    const formControl = formFloating.querySelectorAll('.form-control');
    if (formControl.length > 0) {
      formControl.forEach(control => {
        const formLabel = formFloating.querySelector('.form-label');
        // when user enter or click in input/text aera box
        control.addEventListener('click', () => {
          const formLabelHeight = formLabel.clientHeight;
          control.style.paddingTop = formLabelHeight - 24 + "px";
        });
        // Execute the function on window resize
        window.addEventListener('resize', () => {
          const formLabelHeight = formLabel.clientHeight;
          control.style.paddingTop = formLabelHeight - 24 + "px";
        });
      });
    }
  });
}

// Execute the function on window load
window.addEventListener('load', formContol);

/*******************************************************************************
** End of Form scripts
*******************************************************************************/
